import { LegalPage } from '@gamecodex/portal-ui'
import { LEGAL_DOCS } from './content'
import type { LegalDocKey } from '@gamecodex/portal-ui'

export default function LegalPageRoute({ doc }: { doc: LegalDocKey }) {
  return (
    <div className="app">
      <header className="top">
        <a className="wordmark" href="/">
          DiceTok
        </a>
        <span className="tag">for you, allegedly</span>
      </header>
      <main className="feed legal-cols">
        <LegalPage doc={LEGAL_DOCS[doc]} portal="DiceTok" />
      </main>
    </div>
  )
}
